import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useForm } from '@tanstack/react-form'
import { z } from 'zod'
import { useMutation } from '@tanstack/react-query'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { PublicHeader } from '@/components/PublicHeader'
import { PublicFooter } from '@/components/PublicFooter'
import { sendOtpMutation } from '@/lib/client/@tanstack/react-query.gen'
import { toast } from 'sonner'

export const Route = createFileRoute('/connexion')({
  component: ConnexionPage,
})

function ConnexionPage() {
  const navigate = useNavigate()

  const sendOtp = useMutation({
    ...sendOtpMutation({}), 
     onSuccess: (_, email) => {
      toast.success('Un code a été envoyé à votre email')
      navigate({ to: '/verify', search: { email: email.body.email } })
    },
    onError: () => {
      toast.error('Une erreur est survenue')
    },
  })

  const form = useForm({
    defaultValues: {
      email: '',  
    },
    onSubmit: async ({ value }) => {
      sendOtp.mutate({
        body: { email: value.email}
      })
    },
  })

  return (
    <div className="min-h-screen flex flex-col">
      <PublicHeader />
      <div className="flex-1 flex items-center justify-center px-4 py-12">
        <Card className="w-full max-w-md">
          <CardHeader>
            <CardTitle>Connexion parent</CardTitle>
            <CardDescription>
              Entrez votre email pour recevoir un code de connexion
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form
              onSubmit={(e) => {
                e.preventDefault()
                form.handleSubmit()
              }}
              className="space-y-4"
            >
              <form.Field
                name="email"
                validators={{
                  onChange: ({ value }) => {
                    const result = z.string().email('Email invalide').safeParse(value)
                    return result.success ? undefined : result.error.issues[0]?.message
                  },
                }}
              >
                {(field) => (
                  <div className="space-y-2">
                    <Label htmlFor="email">Email</Label>
                    <Input
                      id="email"
                      type="email"
                      placeholder="parent@example.com"
                      value={field.state.value}
                      onChange={(e) => field.handleChange(e.target.value)}
                      onBlur={field.handleBlur}
                    />
                    {field.state.meta.errors.length > 0 && (
                      <p className="text-sm text-red-500">
                        {field.state.meta.errors[0]}
                      </p>
                    )}
                  </div>
                )}
              </form.Field>

              <Button
                type="submit"
                className="w-full"
                disabled={sendOtp.isPending}
              >
                {sendOtp.isPending ? 'Envoi...' : 'Recevoir le code'}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
      <PublicFooter />
    </div>
  )
}
